import Cookies from "js-cookie";

export const LOGGED_IN_COOKIE_NAME = "corca.isLoggedIn";

/**
 * Note: it only works on the client components
 */
export function setLoggedInCookie(value = true) {
  if (value === true) {
    Cookies.set(LOGGED_IN_COOKIE_NAME, "true", { path: "/" });
  } else {
    Cookies.remove(LOGGED_IN_COOKIE_NAME);
  }
}
